import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { ROLES } from '@/types';

type Props = { children: React.ReactNode; allowedRoles?: string[] };

/** Redirects cashier-level users to POS; unauthenticated users to login. */
export default function AdminRoute({ children, allowedRoles }: Props) {
  const { isAuthenticated, role } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  const roles = allowedRoles || [ROLES.COMPANY_ADMIN];
  if (!roles.includes(role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
